export const quantityAdd = () => {
    return {
        type: 'CART_ITEM_QUANTITY_ADD'
    };
};

export const quantitySubtract = () => {
    return {
        type: 'CART_ITEM_QUANTITY_SUBTRACT'
    };
};

export const cartItemInstructionsUpdate = (instructions) => {
    return {
        type: 'CART_INSTRUCTIONS_UPDATE',
        instructions
    };
};

export const cartItemUpdateId = (id) => {
    return {
        type: 'CART_ITEM_ID_UPDATE',
        id
    };
};

export const cartItemUpdatePizzaType = (pizzatype) => {
    return {
        type: 'CART_ITEM_PIZZATYPE_UPDATE',
        pizzatype
    }
}

export const cartItemUpdatePrice = (price_id, price_name, price_price) => {
    return {
        type: 'CART_ITEM_PRICE_UPDATE',
        price_id,
        price_name,
        price_price
    };
};

export const cartItemUpdateCrust = (crust_id) => {
    return {
        type: 'CART_ITEM_CRUST_UPDATE',
        crust_id
    };
};

export const cartItemUpdateSauce = (sauce_id) => {
    return {
        type: 'CART_ITEM_SAUCE_UPDATE',
        sauce_id
    };
};

export const cartItemUpdateMaxToppings = (max_toppings, toppings = []) => {

    return (dispatch) => {

        if (toppings.length > max_toppings) {
            dispatch(cartItemLoadToppings(toppings.slice(0, max_toppings)));
        }

        dispatch(cartItemLoadMaxToppings(max_toppings));
    };
};

export const cartItemLoadMaxToppings = (max_toppings) => {
    return {
        type: 'CART_ITEM_MAX_TOPPINGS_UPDATE',
        max_toppings
    };
};

export const cartItemLoadToppings = (toppings) => {
    return {
        type: 'CART_ITEM_LOAD_TOPPINGS',
        toppings
    };
};

export const cartItemLoadSpecialItems = (items) => {
    return {
        type: 'CART_ITEM_LOAD_SPECIAL_ITEMS',
        items
    };
};

export const cartItemToggleTopping = (topping_id, cartItemToppings) => {

    let isInToppingsList = false;
    cartItemToppings.forEach((theCartTopping, index) => {
        if (theCartTopping.id == topping_id) {
            isInToppingsList = true;

            if ((theCartTopping.isdefault && theCartTopping.amount == "extra") || (!theCartTopping.isdefault && theCartTopping.amount == "include")) {
                cartItemToppings[index].amount = "none";
            }
            else if (theCartTopping.isdefault && theCartTopping.amount == "include") {
                cartItemToppings[index].amount = "extra";
            }
            else if (!theCartTopping.isdefault && theCartTopping.amount == "none") {
                cartItemToppings[index].amount = "include";
            }
            else {
                cartItemToppings[index].amount = "include";
            }
        }
    });

    if (!isInToppingsList) {

        // it isn't a default item and not there, add it as included
        cartItemToppings.push({
            id: topping_id,
            amount: "include",
            portion: "W",
        });
    }

    return {
        type: 'CART_ITEM_LOAD_TOPPINGS',
        toppings: cartItemToppings
    };
};

export const cartItemToggleCustomTopping = (topping_id, cartItemToppings, max_toppings) => {

    if(cartItemToppings.find((theTopping) => theTopping.id == topping_id)) {

        // it's found in the list of toppings; remove it
        return {
            type: 'CART_ITEM_LOAD_TOPPINGS',
            toppings: cartItemToppings.filter((theTopping) => theTopping.id != topping_id)
        };
    }
    else {

        // it's not found; add it if we haven't reached the top amount of max toppings
        let newCartItemToppings = cartItemToppings;
        if (cartItemToppings.length < max_toppings) {
            newCartItemToppings = cartItemToppings.concat({
                id: topping_id,
                amount: "include",
                portion: "W",
            });
        }

        return {
            type: 'CART_ITEM_LOAD_TOPPINGS',
            toppings: newCartItemToppings
        };
    }
};


export const cartItemTogglePortion = (topping_id, cartItemToppings) => {

    cartItemToppings.forEach((theCartTopping, index) => {
        if (theCartTopping.id == topping_id) {

            if (theCartTopping.portion == "W") {
                cartItemToppings[index].portion = "H1";
            }
            else if (theCartTopping.portion == "H1") {
                cartItemToppings[index].portion = "H2";
            }
            else {
                cartItemToppings[index].portion = "W";
            }
        }
    });

    return {
        type: 'CART_ITEM_LOAD_TOPPINGS',
        toppings: cartItemToppings
    };
};


export const cartItemLoadChoices = (choices) => {
    return {
        type: 'CART_ITEM_LOAD_CHOICES',
        choices
    };
};

export const updateMultipleChoiceSelection = (choice_id, choiceItems, cartChoiceItems, item) => {

    // get the selected choice
    // is the item in the list already?
    let newChoiceItemName = "";
    let items = [];
    const selectedChoice = cartChoiceItems.find((theCartChoice) => {
        return theCartChoice.id == choice_id;
    });

    const selectedItem = selectedChoice.items.find((theItem) => {
        return theItem == item.id;
    });

    if (selectedItem) {

        // it is present, remove it from the list
        items = selectedChoice.items.filter((theItem) => theItem != item.id);
    }
    else if (selectedChoice.items.length < selectedChoice.max_choices) {

         //add the item
        items = selectedChoice.items.concat(item.id);
    }
    else {
        items = selectedChoice.items;
    }

    // get the item name
    items.forEach((theItem) => {
        choiceItems.forEach((theChoiceItem) => {
            if (theItem == theChoiceItem.id) {
                if (newChoiceItemName == "") {
                    newChoiceItemName = theChoiceItem.name;
                }
                else {
                    newChoiceItemName += ", "+theChoiceItem.name;
                }
                if (theChoiceItem.price > 0) {
                    newChoiceItemName += " - "+theChoiceItem.price;
                }
            }
        });
    });

    if (newChoiceItemName == "") {
        newChoiceItemName = "No Items selected.";
    }
   
    return {
        type: 'CART_ITEM_UPDATE_MULTIPLE_CHOICES',
        choice_id,
        items,
        item_name: newChoiceItemName
    };
};

export const updateSingleChoiceSelection = (choice_id, item) => {
    return {
        type: 'CART_ITEM_UPDATE_SINGLE_CHOICE',
        choice_id,
        item
    };
};

export const cartItemLoadModifiers = (modifiers) => {
    return {
        type: 'CART_ITEM_LOAD_MODIFIERS',
        modifiers
    };
};

export const updateSingleModifierSelection = (foodItemModifierID, item) => {
    return {
        type: 'CART_ITEM_UPDATE_SINGLE_MODIFIER',
        foodItemModifierID,
        item
    };
};

export const cartItemAddModifierItem = (foodItemModifierID, item) => {
    return {
        type: 'CART_ITEM_ADD_MODIFIER_ITEM',
        foodItemModifierID,
        item
    };
};

export const cartItemRemoveModifierItem = (foodItemModifierID, item) => {
    return {
        type: 'CART_ITEM_REMOVE_MODIFIER_ITEM',
        foodItemModifierID,
        item
    };
};

export const cartItemAddonAdd = (addon) => {
    return {
        type: 'CART_ITEM_ADDON_ADD',
        addon
    };
};

export const cartItemAddonRemove = (addon) => {
    return {
        type: 'CART_ITEM_ADDON_REMOVE',
        addon
    };
};

export const cartItemReset = () => {
    return {
        type: 'CART_ITEM_RESET'
    };
};